const sessionMixin = {
  methods: {
    saveToLocalStorage(user) {
      localStorage.setItem("user", JSON.stringify(user));
    },
    isAuthenticated() {
      const user = this.getAuthUser();
      return user && user.token;
    },
    getAuthUser() {
      const userInfo = JSON.parse(localStorage.getItem("user"));
      if (userInfo) {
        return {
          id: userInfo.id,
          name: userInfo.name,
          role: userInfo.role,
          token: userInfo.token,
          permissions: userInfo.permissions,
        };
      }
      return null;
    },
    clear() {
      localStorage.clear();
    },
    hasPermission(permissionCode) {
      const user = this.getAuthUser();
      if (user) {
        return user.permissions.includes(permissionCode);
      }
      return false;
    },
  },
};
export default sessionMixin;
